import { useEffect } from 'react';

export const WINDOW: any = window;
export const useScript = (url) =>
{
    useEffect(() =>
    {
        const script = document.createElement('script');
        script.src = url;
        script.type = "text/javascript";

        document.head.appendChild(script);
    }, [url]);
};

export const until = (conditionFunction) =>
{
    const poll = resolve =>
    {
        if (conditionFunction()) resolve();
        else setTimeout(_ => poll(resolve), 400);
    }
    return new Promise(poll);
}